export default "__VITE_ASSET__e348642a__"